/**
 * Redux actions for order close confirmation
 *
 * Handles the state when all actions in an order are validated
 * and the user is asked if they want to close the parent order.
 */

// Action types
export const ORDER_CLOSE_SET_PENDING = 'ORDER_CLOSE_SET_PENDING';
export const ORDER_CLOSE_DECLINE = 'ORDER_CLOSE_DECLINE';
export const ORDER_CLOSE_CLEAR_PENDING = 'ORDER_CLOSE_CLEAR_PENDING';
export const ORDER_CLOSE_REMOVE_DECLINED = 'ORDER_CLOSE_REMOVE_DECLINED';
export const ORDER_CLOSE_RESET = 'ORDER_CLOSE_RESET';

/**
 * Set pending confirmation when all actions are validated.
 * The reducer checks if this order was already declined before setting.
 * @param parentOrderId - ID of the parent order
 * @param parentRoid - ROID of the parent order (for display in modal)
 */
export function orderCloseSetPending(parentOrderId: string, parentRoid?: string) {
  return {
    type: ORDER_CLOSE_SET_PENDING,
    payload: {
      parentOrderId,
      parentRoid,
      triggeredAt: Date.now(),
    },
  };
}

/**
 * User clicked "No, keep open" - add to declined list.
 * Prevents the modal from showing again for this order.
 */
export function orderCloseDecline(parentOrderId: string) {
  return {
    type: ORDER_CLOSE_DECLINE,
    payload: {
      parentOrderId,
    },
  };
}

/**
 * Borra la nota de UNA orden (cerrada, validada o descartada). Sin orden, las
 * borra todas.
 */
export function orderCloseClearPending(parentOrderId?: string) {
  return {
    type: ORDER_CLOSE_CLEAR_PENDING,
    payload: { parentOrderId },
  };
}

/**
 * Remove an order from the declined list.
 * Call when the order changes state (e.g., reopened, or manually closed).
 */
export function orderCloseRemoveDeclined(parentOrderId: string) {
  return {
    type: ORDER_CLOSE_REMOVE_DECLINED,
    payload: {
      parentOrderId,
    },
  };
}

/**
 * Reset all state (on logout or session end)
 */
export function orderCloseReset() {
  return {
    type: ORDER_CLOSE_RESET,
  };
}
